import {
    Field,
    FormikProps,
} from 'formik';

import {I18n} from '@aws-amplify/core';

import {
    PacFormikInput,
    PlatformFieldset
} from "@pac/platform-ui-components";
import {HandoffEmail} from "../types.ts";

export const EmailFormComponent = (props: FormikProps<HandoffEmail>) => {

    const values = props.values;

    return (
        <PlatformFieldset legend={I18n.get('Sign In')}>
            <Field
                type="email"
                name="email"
                label={I18n.get('Email')}
                value={values.email}
                placeholder={I18n.get('Email')}
                component={PacFormikInput}
                autoFocus
                my={'xl'}
            />
        </PlatformFieldset>
    );
};
